<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker
          :disabled-date="disabledDate"
          :disabled="disabledAll"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          placeholder="开始日期"
          v-decorator="[
            'submitdata.salPolicy.effectiveDate',
            { rules: [{ required: true, message: '请选择投保期限' }] },
          ]"
          @change="effectiveDateChange"
          @ok="busDatehanderOk"
        />
        <a-date-picker
          :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
          style="margin-left: 20px"
          disabled
          v-model="applicantInfoExpireDate"
          placeholder="结束日期"
        />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0"
          >共{{ planOffsetDay }}天</span
        >
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人全称">
            <a-input
              v-model="submitdata.salPolicyHolder.name"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.name',
                { rules: [{ required: true, message: '请输入投保人全称' }] },
              ]"
              placeholder="请输入投保人全称"
              @blur="blurCompanyName()"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人证件类型">
            <a-select
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.idType',
                {
                  rules: [{ required: true, message: '请选择投保人证件类型' }],
                },
              ]"
              placeholder="请选择投保人证件类型"
              @change="blurCompanyName"
            >
              <a-select-option
                v-for="item in companyIdTypeOptions"
                :key="item.value"
                :value="item.value"
                >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人证件号码">
            <a-input
              v-model="submitdata.salPolicyHolder.idNumber"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.idNumber',
                {
                  rules: [
                    { required: true, message: '请输入投保人证件号码' },
                  ],
                },
              ]"
              placeholder="请输入投保人证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              v-model="submitdata.salPolicyHolder.contactsname"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              v-model="submitdata.salPolicyHolder.telephone"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.telephone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              v-model="submitdata.salPolicyHolder.email"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        
      </a-row>
      <a-divider />
      <!-- 被保险人 -->
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人全称">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].name',
                { rules: [{ required: true, message: '请输入被保险人全称' }] },
              ]"
              placeholder="请输入被保险人全称"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }">
            <a-checkbox
              :disabled="disabledAll"
              @change="onChangeConSfid"
              :checked="ttbren"
              v-decorator="['submitdata.salInsuredList[0].conSfid']"
            >
              同投保人
            </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人证件类型">
            <a-select
              @change="(value) => handerIdtype(value)"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].idType',
                {
                  rules: [
                    { required: true, message: '请选择被保险人证件类型' },
                  ],
                },
              ]"
              placeholder="请选择被保险人证件类型"
            >
              <a-select-option
                v-for="item in companyIdTypeOptions"
                :key="item.value"
                :value="item.value"
                >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人证件号码">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].idNumber',
                {
                  rules: [
                    { required: true, message: '请输入被保险人证件号码' },
                  ],
                },
              ]"
              placeholder="请输入被保险人证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].linkmanname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].mobile',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider />
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="共同被保险人">
            <a-input
              :disabled="disabledAll"
              v-decorator="['submitdata.salPolicyHolder.additionalinsured']"
              placeholder="可用于填写其他关系方"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="第一受益人">
            <a-input
              :disabled="disabledAll"
              v-decorator="['submitdata.salPolicyHolder.firstbeneficiary']"
              placeholder="非必填项，按需填写"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24"> </a-row>
      <!-- 项目信息 -->
      <a-divider />
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="营业面积">
            <a-input-number
              v-model="submitdata.salPolicyHolder.area"
              :disabled="disabledAll"
              :min="0" 
              :max="5000"
              @blur="busDatehanderOk"
              v-decorator="[
                'submitdata.salPolicyHolder.area',
                {
                  rules: [{ required: true, message: '请输入营业面积' }],
                },
              ]"
              placeholder="请输入营业面积（平米）"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="营业性质">
            <a-select
              :disabled="disabledAll"
              v-model="submitdata.salPolicyHolder.companytype"
              @select="busDatehanderOk"
              v-decorator="[
                'submitdata.salPolicyHolder.companytype',
                {
                  rules: [{ required: true, message: '请选择营业性质' }],
                },
              ]"
              placeholder="请选择营业性质"
            >
              <a-select-option
                v-for="item in YYXZOptios"
                :key="item.value"
                :value="item.value"
                >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="营业场所地址">
          <a-col :span="12">
            <a-select
              class="after-text"
              style="width: 100%"
              placeholder="请选择营业场所地址"
              @change="(value, iv) => handleChangeYYaddress(value, iv)"
              option-filter-prop="children"
              :filter-option="filterOption"
              showSearch
              :disabled="disabledAll"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
              v-decorator="[
                'submitdata.salPolicyHolder.addresscode',
                {
                  rules: [{ required: true, message: '输入不能为空' }],
                },
              ]"
            >
              <a-select-option
                v-for="item in YYAddressOptions"
                :key="item.id"
                :label="item.detailaddress"
                :value="item.id"
              >
                {{ item.detailaddress }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-form-item
          :label-col="{ span: 4 }"
          label="单元号或铺位号或品牌"
          style="padding: 0 12px"
        >
          <a-input
            :disabled="disabledAll"
            style="width: 100%"
            v-model="submitdata.salPolicyHolder.shopsname"
            v-decorator="[
              'submitdata.salPolicyHolder.shopsname',
              {
                rules: [{ required: true, message: '输入不能为空' }],
              },
            ]"
            placeholder="请填写具体铺位号，勿重复填写上述商铺地址"
          ></a-input>
        </a-form-item>
      </a-row>
      <!-- <a-row :gutter="24">
        <a-form-item
          :label-col="{ span: 3 }"
          label="备注"
          style="padding: 0 12px"
        >
          <a-input
            :disabled="disabledAll"
            style="width: 100%"
            v-model="submitdata.salPolicy.remark"
            v-decorator="['submitdata.salPolicy.remark']"
            placeholder="请输入备注"
          ></a-input>
        </a-form-item>
      </a-row> -->
      <a-row :gutter="24">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="12">
          <a-form-item label="保费" :label-col="{ span: 2 }">
            <a-col :span="6">
              <a-input
                v-model="eduitPremium"
                disabled
                style="min-width: 130px"
                addonAfter="元"
              />
            </a-col>
            <a-col class="btn_list">
              <a-button
                class="btn_color"
                :disabled="disabledAll"
                type="primary"
                @click="changePremium"
              >
                修改保费
              </a-button>
            </a-col>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="支付方式">
            <a-select
              style="width: 100%"
              placeholder="请选择支付类型"
              @change="value => handleChange(value, 'payMethod')"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicy.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }],
                },
              ]"
            >
              <a-select-option
                v-for="item in payTypeList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="24">环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select :disabled="disabledAll" placeholder="请选择" @change="invoiceprinttypeChange" v-decorator="[
                'submitdata.invoiceprinttype',
                { rules: [{ required: true, message: '请选择' }] },
              ]">
              <a-select-option value="03">暂不开票</a-select-option>
              <a-select-option value="01">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="submitdata.invoiceprinttype == '01'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input :disabled="disabledAll" v-model="submitdata.taxpayercertificateno" v-decorator="[
                'submitdata.taxpayercertificateno',
                { rules: [{ required: true, message: '请输入纳税人识别号' }] },
              ]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled='!agreementAllRead' @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意<fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <!-- <a-button
              v-show="checkContent.riskNotifyFlag == '1' && disabledAll"
              class="btn_color"
              type="primary"
              @click="fileListClick"
            >
              文件列表
            </a-button> -->
            <a-button
              class="btn_color"
              type="primary"
              :loading="submitLoad1"
              v-show="!disabledAll"
              @click="handleSubmit"
            >
              保存订单
            </a-button>
            <a-button
              style="margin-left: 24px"
              class="btn_color"
              type="primary"
              v-show="disabledAll"
              @click="fastInsure"
            >
              <!-- :loading="submitLoad2" -->
              立即投保
            </a-button>
            <a-button
              style="margin-left: 24px"
              class="btn_color"
              type="primary"
              v-show="disabledAll"
              @click="gonOne"
            >
              编辑
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal
      v-model="modalVisible"
      title="修改保费"
      cancelText="取消"
      okText="确定"
      @ok="handleOk"
    >
      <div>
        <div>
          请输入要修改的保费(如不输入则按原值({{
            submitdata.salPolicy.totalPremium
          }})计算)：
          <a-input-number
            class="level_"
            :min="parseFloat(submitdata.salPolicy.totalPremium)"
            v-model="eduitPremium"
          />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal
      class="myModal_"
      width="500px"
      title="支付确认"
      forceRender
      v-model="showPaySure"
      @ok="paySure"
      okText="确定"
      cancelText="关闭"
    >
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName() }}需支付保费
        <span style="color: #fe8f2d; font-weight: bold">{{
          submitdata.salPolicy.totalPremium
        }}</span
        >&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import moment from "moment";
const LOAD_NUM = 30; // 加载条数--可自定义
import { policyMixin } from '@/mixins/policyMixin.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  mixins: [policyMixin],
  data() {
    //这里存放数据
    return {
      yueduBtn: false, //理解阅读
      saveBtnShow: false, //保存过
      submitLoad1: false, //保存中
      // submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: "", //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      // companyPropertyList: require("../js/companyPropertyList.json"),
      rate: 0.2, //费率
      industrycodeTEXT: "", //四级行业的文本
      mobilestringcode: "0;0;0;0;0", //每一类添加的保费
      maxType: 1, //最大类别
      companyCode: "01", //企业性质
      planinfos: "0;0;0", //基础保费
      perRiskInfo: "", //险种类
      evidenceNumber: "", //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      //营业性质
      YYXZOptios: require("../js/YYXZOptios.json"),
      //投保人证件类型
      companyIdTypeOptions: [
        {
          value: "01",
          name: "组织机构代码",
        },
        {
          value: "02",
          name: "税务登记证",
        },
        {
          value: "04",
          name: "工商营业执照",
        },
        {
          value: "99",
          name: "其他",
        },
      ],
      YYAddressOptions: [], //营业地址
      loading: false,
      form: this.$form.createForm(this, { name: "advanced_search" }),
      submitdata: {
        salInsuredList: [
          //被保人集合
          {
            name: "",
            idType: "",
            idNumber: "",
            linkmanname: "",
            mobile: "",
            email: "",
            conSfid: false, //是否同投保人   1:是，0：否
            occupationName: "",
            occulevel: "",
            premium: "",
          },
        ],
        salPolicy: {
          //保单信息
          effectiveDate: "",
          expireDate: "",
          coverageamount: "",
          totalPremium: 0,
          productCode: "YTJGYQX", //YTJGYQX
          planCode: "YTJGYQX", //YTJGYQX
          payMethod: "",
          remark: "",
          creator: "",
        },
        salPolicyHolder: {
          //投保人信息
          type: "C", //固定值
          name: "",
          idType: "",
          idNumber: "",
          contactsname: "",
          telephone: "",
          email: "",
          province: "",
          city: "",
          district: "",
          projectaddress: "",
          companytype: "", //营业性质
          area: "", //营业面积
          shopsname: "", //单元号/或铺位号/或品牌
          firstbeneficiary: "",
          additionalinsured: "",
          address: "", //营业场所地址
          addresscode: "", //对应/getBusinessPremisesDetailAddress接口返回的id
          invoiceprinttype:'03', //发票类型  默认03不开票（普通发票：01、暂不开票：03"）
          taxpayercertificateno: "", //纳税人识别号
        },
        riskInfos: [
          {
            riskCode: "GZZR",
            amount: undefined, //公众责任险保额（每次事故及累计赔偿限额）
          },
          {
            riskCode: "GGZS",
            amount: "1", //广告及装饰装置责任条款
          },
          {
            riskCode: "JJFY",
            amount: "1", //急救费用条款
          },
          {
            riskCode: "SPYLZR",
            amount: "1", //食品、饮料责任条款
          },
          {
            riskCode: "GLYLBZ",
            amount: "1", //锅炉及压力容器爆炸扩展条款
          },
          {
            riskCode: "ZDGGR",
            amount: "1", //指定公估人条款
          },
          {
            riskCode: "HZBZSS",
            amount: "1", //附加火灾、爆炸、烟熏、水损责任保险
          },
          {
            riskCode: "MHZSS",
            amount: "1", //灭火及所致水损责任条款
          },
          {
            riskCode: "JXZRA",
            amount: "1", //交叉责任条款A
          },
          {
            riskCode: "FQZC",
            amount: "1", //放弃追偿条款
          },
          {
            riskCode: "JZWGB",
            amount: "1", //建筑物改变条款
          },
          {
            riskCode: "RSQH",
            amount: "1", //人身侵害责任条款
          },
          {
            riskCode: "ZHZR",
            amount: "1", //承租人责任条款
          },
          {
            riskCode: "QYZRB",
            amount: "0", //契约责任扩展条款B(每次事故及累计赔偿限额：50万)
          },
          {
            riskCode: "CLZX",
            amount: "0", //车辆装卸责任条款（每次事故及累计赔偿限额：10万）
          },
          {
            riskCode: "KRCCZR",
            amount: "0", //客人财产责任条款
          },
          {
            riskCode: "CZRZR",
            amount: "0", //出租人责任条款
          },
        ],
      }, //测算的数据
      pcCode: [], //省市区的数组
      effectiveDate: "", //保单时间
      ttbren: false, //同投保人
      eduitPremium: 0, //要修改的保费

      modalVisible: false, //修改保费的弹窗
      CScontent: {},
      ContentView: {}, //展示的保费
      copyCScontent: {}, //拷贝的
      creator: "1",
      productCode: "",
      plan: "",
      userParams: "",
      /**需要的数据结束 */
      planOffsetDay: 0,
      baodanData: {
        startdata: "",
      },
      startValues: null,
      linshiContent: {},
      riskInfosAmount: {}, //计算险种的结果
      ZBAOFEI: 0, //原始保费
      addBAOFEI: 0, //修改添加的保费
      orderContent: {}, //订单的数据
      disabledAll: false, //是否是立即投保
      gztypestr: "",
      searchVal: "", // 搜索的内容
      filterDataList: [], // 过滤的数据列表 -- 从dataList中过滤出含搜索内容的数据
    };
  },
  //监听属性 类似于data概念
  computed: {
    applicantInfoExpireDate() {
      var mon = 12;
      let t2
      if (this.submitdata.salPolicy.effectiveDate) {
        t2 = moment(this.submitdata.salPolicy.effectiveDate).add(mon, 'months').subtract(1, 's')
      }
      return t2;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    async blurCompanyName(val) {
      if(val) {
        this.submitdata.salPolicyHolder.idType = val       
      }
      let name = this.submitdata.salPolicyHolder.name
      let type = this.submitdata.salPolicyHolder.idType
      var reg = new RegExp('[\u4e00-\u9fa5]+', 'g'); //验证如果不是只包含汉字 返回
      if (!reg.test(name)) {
        return;
      }
      if(!type) {
        return
      }
      if(this.submitdata.salPolicyHolder.idType !== '01' && this.submitdata.salPolicyHolder.idType !== '04') {
        this.form.setFieldsValue({
          submitdata: {
            salPolicyHolder: {
              idNumber: '',
            },
          },
        });
        this.submitdata.salPolicyHolder.idNumber = ''
        return
      }
      let idType = this.submitdata.salPolicyHolder.idType == '01' ? 2 : 1
      let code = await this.queryCompanyListByName(name, idType) || ''
      console.log(code)
      this.form.setFieldsValue({
        submitdata: {
          salPolicyHolder: {
            idNumber: code,
          },
        },
      });
      this.submitdata.salPolicyHolder.idNumber = code
      this.$forceUpdate()
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.submitdata.invoiceprinttype = value;
    },
    filterOption(input, option) {
      console.log(input, option);
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //选择营业场所地址
    handleChangeYYaddress(value, iv) {
      console.log(iv.componentOptions.propsData.label);
      console.log(`selected ${value}`);
      this.submitdata.salPolicyHolder.address =
        iv.componentOptions.propsData.label;
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.submitdata.salPolicy.effectiveDate = date;
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    //校验第三责任金额
    checkPrice(rule, value, callback) {
      if (value >= 500000) {
        callback();
        return;
      }
      callback("第三者责任限额最低50万起保!");
    },
    //同投保人
    onChangeConSfid(e) {
      console.log("checked = ", e.target.checked);
      this.ttbren = e.target.checked;
      console.log(this.submitdata);
      if (this.ttbren) {
        this.form.setFieldsValue({
          submitdata: {
            salInsuredList: [
              {
                name: this.submitdata.salPolicyHolder.name,
                idType: this.submitdata.salPolicyHolder.idType,
                idNumber: this.submitdata.salPolicyHolder.idNumber,
                linkmanname: this.submitdata.salPolicyHolder.contactsname,
                mobile: this.submitdata.salPolicyHolder.telephone,
                email: this.submitdata.salPolicyHolder.email,
              },
            ],
          },
        });
      }
    },
    handerIdtype(value) {
      this.ttbren = false;
      this.submitdata.salInsuredList[0].idType = value;
    },
    //时间限制
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + "-" + m + "-" + d;
      var currents = moment(time);
      return current < currents || current > moment(currents).add(1, "year");
    },
    gonOne() {
      this.disabledAll = false;
      this.addBAOFEI = this.$accuracy.sub(
        this.submitdata.salPolicy.totalPremium,
        this.ZBAOFEI
      );
      console.log(this.addBAOFEI);
      this.$bus.$emit("disabledBus", false);
      this.$router.push({
        name: "paggzr",
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode,
        },
      });
      this.handleSearch()
    },
    //打开文件列表
    fileListClick() {
      this.$store.commit("setNotShow", true);
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId,
      };
      this.$api
        .queryOrderDetails(parms)
        .then((res) => {
          if (res.data.returnCode == "00") {
            if (res.data.content) {
              this.orderContent = res.data.content;
              this.$store.commit("setOrderContent", this.orderContent);
              this.form.setFieldsValue({
                submitdata: { ...res.data.content },
              });
              this.submitdata = { ...res.data.content };
              console.log(this.submitdata);
              if (res.data.content.salPolicy) {
                let salPolicy = res.data.content.salPolicy;
                this.eduitPremium = salPolicy.totalPremium
                this.submitdata.salPolicy.payMethod = salPolicy.payMethod
                this.form.setFieldsValue({
                  submitdata: {
                    salPolicy: {
                      effectiveDate: moment(
                        new Date(salPolicy.effectiveDate),
                        "YYYY-MM-DD"
                      ),
                    },
                  },
                });
                this.submitdata.salPolicy.effectiveDate =
                  salPolicy.effectiveDate
                    ? moment(new Date(salPolicy.effectiveDate), "YYYY-MM-DD")
                    : "";
              }
              if (res.data.content.salPolicyHolder) {
                let salPolicyHolder = res.data.content.salPolicyHolder;
                this.submitdata.invoiceprinttype =
                    salPolicyHolder.invoiceprinttype;
                  this.submitdata.taxpayercertificateno =
                    salPolicyHolder.taxpayercertificateno;
                this.form.setFieldsValue({
                  submitdata: {
                    salPolicyHolder: salPolicyHolder,
                  },
                });
                this.$nextTick(()=>{
                  this.form.setFieldsValue({
                    submitdata: {
                      invoiceprinttype:salPolicyHolder.invoiceprinttype,
                      taxpayercertificateno:salPolicyHolder.taxpayercertificateno,
                    },
                  });
                })
              }
              if (res.data.content.salInsuredList) {
                let salInsuredList = res.data.content.salInsuredList;
                this.ttbren = salInsuredList[0].conSfid == "1" ? true : false;
              }
              this.$parent.$refs.riskInfo.busOnDataMethod();
            }
          }
        })
    },
    Filtergztypestr(data) {
      let newData = data.split(";").slice(8, -1);
      let obj = {};
      newData.forEach((e, i) => {
        obj[i + 1] = e;
      });
      return obj;
    },
    //确认修改
    handleOk() {
      this.modalVisible = false;
    },
    //修改保费
    changePremium() {
      if (!this.submitdata.salPolicy.totalPremium) {
        this.$message.error("您还没有计算保费");
        return;
      }
      this.modalVisible = true;
    },
    filter(inputValue, path) {
      return path.some((option) => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.submitdata.premiumBaseDtoList.forEach((e) => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        console.log(key);
        resultnum += a[key] * data[key];
      }
      console.log(resultnum, "总保费");
      return resultnum.toFixed(2);
    },
    //触试算
    busDatehanderOk() {
      this.$parent.$refs.riskInfo.busOnDataMethod();
      this.countPremiumSum();
    },
    salInsuredList(data) {
      data.forEach((e) => {
        console.log(e);
        if (e["gender"] == "男" || e["gender"] == "M") {
          e["gender"] = "M";
        } else {
          e["gender"] = "F";
        }
        let leiocc = Number(e.occulevel.toString().slice(0, 1));
        e["occulevel"] = Number(e.occulevel.toString().slice(0, 1));
        console.log(this.copyCScontent);
        e["premium"] = Number(this.copyCScontent[leiocc]);
      });
      return data;
    },
    //处理险种信息
    filterRiskInfo(data) {
      console.log(data, "处理前");
      data.forEach((e) => {
        if (e.dutyCode == "631001" && e.riskCode == "060099") {
          e.premiumAmt = this.$accuracy.add(
            Number(this.riskInfosAmount[e.dutyCode] || 0),
            this.addBAOFEI
          );
        } else {
          e.premiumAmt = this.riskInfosAmount[e.dutyCode] || 0;
        }
      });
      console.log(data, "处理后");
      return data.filter((item) => item.amount > 0);
    },
    //最后的提交
    handleSubmit() {
      let ageStatus = true;
      if (!ageStatus) {
        return;
      }
      if (this.submitdata.salPolicyHolder.area>5000) {
        this.$message.warning("营业面积不超过5000平方米",2);
        return
      }
      this.form.validateFields((err, values) => {
        console.log(values, "表单数据");
        console.log(this.submitdata, "submitdata页面数据");
        this.submitdata.salPolicy.totalPremium = this.eduitPremium;
        if (!err) {
          let data = {
            salInsuredList: [
              {
                name: values.submitdata.salInsuredList[0].name,
                idType: values.submitdata.salInsuredList[0].idType,
                idNumber: values.submitdata.salInsuredList[0].idNumber,
                linkmanname: values.submitdata.salInsuredList[0].linkmanname,
                mobile: values.submitdata.salInsuredList[0].mobile,
                email: values.submitdata.salInsuredList[0].email,
                conSfid: values.submitdata.salInsuredList[0].conSfid ? 1 : 0, //是否同投保人   1:是，0：否
                occupationName: "",
                occulevel: "",
                premium: "",
              },
            ],
            salPolicy: {
              //保单信息
              effectiveDate: this.submitdata.salPolicy.effectiveDate
                ? moment(this.submitdata.salPolicy.effectiveDate).format("YYYY-MM-DD")
                : "",
              expireDate: this.applicantInfoExpireDate
                ? moment(this.applicantInfoExpireDate).format("YYYY-MM-DD")
                : "",
              coverageamount: "",
              id: this.policyId,
              totalPremium: this.submitdata.salPolicy.totalPremium,
              productCode: this.$route.query.p, //YTJGYQX
              planCode: this.$route.query.p, //YTJGYQX
              payMethod: values.submitdata.salPolicy.payMethod,
              remark: values.submitdata.salPolicy.remark,
              creator: this.$route.query.u,
            },
            salPolicyExt: {
              isworkheightinvolved: "2", //是否高空作业
              occEmpVersion: "",
              occuRiskPremium: "",
            },
            salPolicyHolder: {
              //投保人信息
              type: "C", //固定值
              name: values.submitdata.salPolicyHolder.name,
              idType: values.submitdata.salPolicyHolder.idType,
              idNumber: values.submitdata.salPolicyHolder.idNumber,
              contactsname: values.submitdata.salPolicyHolder.contactsname,
              telephone: values.submitdata.salPolicyHolder.telephone,
              email: values.submitdata.salPolicyHolder.email,
              // province: this.pcCode[0], //省
              // city: this.pcCode[1], //市
              // district: this.pcCode[2], //区
              address: this.submitdata.salPolicyHolder.address,
              addresscode: values.submitdata.salPolicyHolder.addresscode,
              projectaddress: values.submitdata.salPolicyHolder.projectaddress,
              area: values.submitdata.salPolicyHolder.area,
              companytype: values.submitdata.salPolicyHolder.companytype, //营业性质
              shopsname: values.submitdata.salPolicyHolder.shopsname,
              firstbeneficiary:
                values.submitdata.salPolicyHolder.firstbeneficiary,
              additionalinsured:
                values.submitdata.salPolicyHolder.additionalinsured,
              invoiceprinttype: values.submitdata.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
              taxpayercertificateno: values.submitdata.taxpayercertificateno,
              taxpayercertificatetype: '01'
            },
            riskInfos: this.submitdata.riskInfos.filter(
              (item) => item.amount > 0
            ),
          };
          console.log(data, "处理好的数据");
          this.postPolicyData = data;
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.$store.commit("setproductCode", this.productCode);
          //判断是否选择了险种信息
          let otherData = this.$parent.$refs.riskInfo.countData;
          if (!otherData.GZZR) {
            this.$warning({
              title: "温馨提示",
              content: "请先选择险种信息",
              okText: "知道了",
              onOk() {
                window.scrollTo({
                  behavior: "smooth",
                  top: 0,
                });
              },
              onCancel() {
                window.scrollTo({
                  behavior: "smooth",
                  top: 0,
                });
              },
            });
            return;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error("请填写完整提交的数据");
        }
      });
    },
    //立即投保
    fastInsure(){
      if (!this.yueduBtn) {
        this.$message.warning(
          "请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》",
          2
        );
        return;
      }
      this.showPaySure = true;
    },
    axiosPolicy() {
      //提交保单
      this.$api
        .addPAPolicy(this.postPolicyData)
        .then((res) => {
          if (res.data.returnCode == "00") {
            console.log(res);
            this.showPaySure = false;
            this.saveBtnShow = true;
            this.policyId = res.data.content;
            this.$message.success("保存成功！");
            this.$router.push({
              name: "paggzr",
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                planCode: this.$route.query.planCode,
              },
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });

    },
    //保费试算
    countPremiumSum() {
      let allData = this.$parent.$refs.riskInfo.allData;
      let countData = this.$parent.$refs.riskInfo.countData;
      if (countData.YYXZ && countData.YYMJ && countData.GZZR) {
        this.$api.calPremiumEmployer(allData).then((res) => {
          if (res.data.success) {
            if (res.data.content && res.data.content > 0) {
              this.submitdata.salPolicy.totalPremium = res.data.content;
              this.eduitPremium = this.submitdata.salPolicy.totalPremium;
              console.log(this.submitdata.salPolicy.totalPremium);
              this.form.setFieldsValue({
                submitdata: {
                  salPolicy: {
                    totalPremium: res.data.content,
                  },
                },
              });
            }
          } else {
            this.$message.error(res.data.returnMsg + "错误");
          }
        });
      }
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: "paggzr", //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.submitdata.salPolicy.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.submitdata.salPolicy.totalPremium, //支付总金额
        name: this.submitdata.salPolicy.name,
      });
    },
    handleChange(value, type) {
      if (type == "pcCode") {
        this.pcCode = value;
      }
      if (type == "payMethod") {
        this.submitdata.salPolicy.payMethod = value
      }

    },
    busDataMethod() {
      let strdata = this.$lodash.cloneDeep(this.$parent.$refs.riskInfo.allData);
      console.log(strdata, "接受到的数据");
      if (JSON.stringify(strdata) != "{}" && strdata.salPolicy.effectiveDate) {
        this.form.setFieldsValue({
          submitdata: {
            salPolicy: {
              effectiveDate: strdata.salPolicy.effectiveDate
                ? moment(strdata.salPolicy.effectiveDate, "YYYY-MM-DD")
                : "",
            },
            salPolicyHolder: {
              area: strdata.salPolicyHolder.area,
              companytype: strdata.salPolicyHolder.companytype,
            },
          },
        });
      }
      for (const key in strdata) {
        if (key == "riskInfos") {
          this.submitdata.riskInfos = strdata.riskInfos;
        } else {
          this.submitdata[key] = Object.assign(
            {},
            this.submitdata[key],
            strdata[key]
          );
        }
      }
      if (!this.disabledAll) {
        this.countPremiumSum();
      }
      console.log("ankeji", this.submitdata);
    },
    // 优化下拉框的部分开始
    // 处理回显问题
    filterShowAddress(code){
      if (window.yyaddress) {
        let val = window.yyaddress.filter(item=>item.id==code)
        this.handleSearch(val[0].detailaddress)
      }
    },
    getYingYeAddress(productCode) {
      if (productCode=='pagongzesfA') {
        productCode = 'gongzhongbf2018A'
      }
      if (productCode=='pagongzesfB') {
        productCode = 'gongzhongbf2018B'
      }
      if (window.yyaddress) {
        this.YYAddressOptions = window.yyaddress.slice(0, LOAD_NUM);
        this.filterShowAddress(this.submitdata.salPolicyHolder.addresscode)
      } else {
        this.$api.getYingYeAddress(productCode).then((res) => {
          if (res.data.returnCode == "00") {
            let data = JSON.parse(res.data.content) || [];
            window.yyaddress = data;
            this.YYAddressOptions = window.yyaddress.slice(0, LOAD_NUM);
          }
        }).then(()=>{
           this.filterShowAddress(this.submitdata.salPolicyHolder.addresscode)
        });
      }
    },
    // 文本框值变化时触发 -- 从数据源中过滤出含搜索内容的数据，并取过滤结果的前n条作为下拉列表的可选项
    handleSearch(val) {
      let filterList = [];
      this.searchVal = val;
      let alllist = window.yyaddress;
      if (val) {
        filterList = alllist.filter((item) => item.detailaddress.indexOf(val) > -1);
      } else {
        filterList = alllist;
      }
      this.filterDataList = filterList;
      this.YYAddressOptions =
        filterList.length < LOAD_NUM
          ? filterList
          : filterList.slice(0, LOAD_NUM);
    },
    // 滚动时触发（防止抖动）
    handlePopupScroll:function () {
      let alllist = window.yyaddress;
      if (this.searchVal === "") {
        this.loadMoreData(alllist);
      } else {
        this.loadMoreData(this.filterDataList);
      }
    },
    // 加载更多数据到select框
    loadMoreData(dataList) {
      const renderedLen = this.YYAddressOptions.length; // 已渲染的下拉列表长度
      const totalLen = dataList.length; // 当前数据源的长度
      let addList = [];
      if (renderedLen < totalLen) {
        if (renderedLen + LOAD_NUM <= totalLen) {
          addList = dataList.slice(renderedLen, renderedLen + LOAD_NUM);
        } else {
          addList = dataList.slice(
            renderedLen,
            renderedLen + (totalLen % LOAD_NUM)
          );
        }
        this.YYAddressOptions = this.YYAddressOptions.concat(addList);
      }
    },
    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect(val) {
      let alllist = window.yyaddress;
      if (this.searchVal) {
        const selectedArr = alllist.filter((item) => item.id === val); // 从数据源中过滤出下拉框选中的值，并返回一个数组
        const restList = alllist.filter((item) => item.id !== val); // 从数据源中过滤出其他的值，返回一个数组
        const newList = selectedArr.concat(restList).slice(0, LOAD_NUM); // 将选中的元素放到下拉列表的第一位
        this.YYAddressOptions = newList; // 更新已渲染的下拉列表
        alllist = selectedArr.concat(restList); // 更新数据源
        this.searchVal = ""; // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
      }
    },
    // 优化下拉框的部分结束
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const {p} = this.$route.query;
    this.productCode = p; //产品code
    this.getYingYeAddress(this.productCode);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.btn_color {
  margin: 0 20px;
}
.after-text {
  position: relative;
}
.after-text::after {
  content: "如未查到商场地址，请联系客服!";
  position: absolute;
  color: #fe8f2d;
  top: 9px;
  right: -212px;
  z-index: 2;
}
</style>
